import React from 'react';
import { useNavigate } from 'react-router-dom';

const UpgradeCTA = ({ message, variant = 'default', ctaText, onUpgrade }) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    if (onUpgrade) {
      onUpgrade();
    } else {
      navigate('/upgrade');
    }
  };

  if (variant === 'banner') {
    return (
      <div className="bg-gradient-to-r from-primary/10 via-primary/5 to-transparent border border-primary/20 rounded-lg p-6">
        <div className="flex items-center justify-between gap-4">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-2">
              <span className="text-2xl">🔒</span>
              <h3 className="text-lg font-semibold text-foreground">Unlock Full Analysis</h3>
            </div>
            <p className="text-sm text-muted-foreground">
              {message || "Upgrade to unlock skill gaps, learning roadmap, interview prep, and more."}
            </p>
          </div>
          <button
            onClick={handleUpgrade}
            className="px-6 py-2 bg-primary text-primary-foreground rounded-md font-medium hover:bg-primary/90 transition-colors whitespace-nowrap"
          >
            Upgrade Now
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-muted/50 border border-border rounded-lg p-6 text-center space-y-4">
      <div className="text-4xl mb-2">🔒</div>
      <h3 className="text-lg font-semibold text-foreground">Premium Feature</h3>
      <p className="text-sm text-muted-foreground">
        {message || "Upgrade to unlock this feature and get full insights."}
      </p>
      <button
        onClick={handleUpgrade}
        className="px-6 py-2 bg-primary text-primary-foreground rounded-md font-medium hover:bg-primary/90 transition-colors"
      >
        Upgrade to Premium
      </button>
    </div>
  );
};

export default UpgradeCTA;